import React, {useState} from "react";
import {v4} from "uuid";

function AddListItem({formId, addListItem, listItems, name, id, type, max, min}) {
	const [listItem, setListItem] = useState('');

	function handleSubmit() {
		if (listItem && !listItems.map(value => value.value).includes(listItem.trim())) {
			const newListItem = {
				value: listItem.trim(),
				id: v4()
			};
			addListItem(newListItem);
			setListItem('');
		}
	}

	return (
		<div>
			<label htmlFor={formId + id} className={"form-label"}>{name}:</label>
			<input type={type} id={formId + id} required={listItems.length < min} disabled={listItems.length == max} placeholder={listItems.length == max ? "You have reached the maximum number of list items": "Please add a minimum of " + min + " list items. (Press enter to add list item)"}
				   className="form-control" value={listItem} onKeyDown={(e) => {
				if (e.key === 'Enter') {
					e.preventDefault();
					e.stopPropagation();
					handleSubmit();
				}
				if (type === 'number') {
					if (e.key === 'Backspace' || e.key.startsWith('Arrow')) {
						return;
					}
					// Only allow digits
					if (/^[0-9]$/.test(e.key)) {
						if (e.key === '0' && listItem === '') {
							e.preventDefault();
						}
						return;
					}
					e.preventDefault();
				}
			}} onChange={(evt) => {
				if (type === 'number') {
					const value = evt.target.value;
					if (value === '' || parseInt(value) >= 1) {
						setListItem(value);
					}
				} else {
					setListItem(evt.target.value);
				}
			}}/>
		</div>
	);
}

export default AddListItem;
